import { Spinner } from "@chakra-ui/react";
import React from "react";

const LoadingBlock = () => {
  return (
    <div className="flex justify-center py-3">
      <Spinner />
    </div>
  );
};

export default LoadingBlock;
